export function XOR(p, q) {
   const boolP = !!p;
   const boolQ = !!q;
   return boolP ? !boolQ : boolQ;
}
